var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Message 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.47338C9.47715 5.47338 5 10.0055 5 15.5962C5 17.7373 5.65531 19.7197 6.77396 21.3539C7.14417 21.8948 7.23341 22.6168 6.94016 23.2555L5.80911 25.719H15C20.5229 25.719 25 21.1868 25 15.5962C25 10.0055 20.5229 5.47338 15 5.47338ZM2.5 15.5962C2.5 8.60784 8.09644 2.94269 15 2.94269C21.9036 2.94269 27.5 8.60784 27.5 15.5962C27.5 22.5845 21.9036 28.2496 15 28.2496H4.82699C3.40921 28.2496 2.51233 26.7228 3.16757 25.4679L4.52719 22.5066C3.24526 20.5195 2.5 18.1442 2.5 15.5962Z",
    fill: "url(#paint0_linear_1_378)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 33490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.1269C10 17.428 10.5596 16.8615 11.25 16.8615H18.75C19.4404 16.8615 20 17.428 20 18.1269C20 18.8257 19.4404 19.3922 18.75 19.3922H11.25C10.5596 19.3922 10 18.8257 10 18.1269Z",
    fill: "url(#paint1_linear_1_378)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 33491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.0655C10 12.3666 10.5596 11.8001 11.25 11.8001H13.75C14.4404 11.8001 15 12.3666 15 13.0655C15 13.7643 14.4404 14.3308 13.75 14.3308H11.25C10.5596 14.3308 10 13.7643 10 13.0655Z",
    fill: "url(#paint2_linear_1_378)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_378",
    x1: 2.92049,
    y1: 2.94268,
    x2: 28.0361,
    y2: 3.48643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_378",
    x1: 10.1682,
    y1: 16.8615,
    x2: 20.1443,
    y2: 17.7254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_378",
    x1: 10.0841,
    y1: 11.8001,
    x2: 15.1002,
    y2: 12.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.be016b429aaca44cc85a12175fff0010.svg";
export { ForwardRef as ReactComponent };